import createReducer from "../lib/createReducer";
import * as types from "../actions/types";

const fetch_locations_state = {};
export const DATA_fetch_locations = createReducer(fetch_locations_state, {
  [types.FETCH_LOCATIONS](state, action) {
    let newState = fetch_locations_state;
    newState = Object.assign({}, newState, action.value);
    return newState;
  }
});

const set_geolocations_state = {};
export const dataGeoLocations = createReducer(set_geolocations_state, {
  [types.SET_GEOLOCATIONS](state, action) {
    let newState = set_geolocations_state;
    newState = Object.assign({}, newState, action.value);
    return newState;
  }
});
